import React, { FC } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { system } from '@everfi/design-system';
import { ErrorPage as ErrorPageUDL } from './component';
import { ErrorPage as ErrorPageLegacy } from './component.legacy';
import { Props } from './types';

export const ErrorPage: FC<Props> = props => {
  if (props.renderAsLegacy || (props.chakra && props.chakra === 'off')) {
    return <ErrorPageLegacy {...props} />;
  }
  // ErrorBoundary fallbacks may sit above any ChakraProvider, so this brings a plain one: ChakraUIProvider's
  // context-free first render would crash this fallback, and a nested second provider is harmless.
  return (
    <ChakraProvider value={system}>
      <ErrorPageUDL {...props} />
    </ChakraProvider>
  );
};
